import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import Logo from "./Logo";
import SocialIcons from "./SocialIcons";
import { openInMapsApp, SOCIETY_ADDRESS } from "../lib/maps";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0a0a0a] border-t border-white/5 mt-6">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <Logo size="md" />
            <p className="mt-6 text-white/55 text-sm leading-relaxed max-w-xs">
              Ambridge's destination for edgy luxury and elevated self-care.
              A movement of bold beauty, raw rituals, and unapologetic glow.
            </p>
            <div className="flex items-center gap-3 mt-7">
              <SocialIcons />
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg text-white/90 mb-5 tracking-wide">Explore</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-white/65 hover:text-[var(--accent)] transition-colors">Home</Link></li>
              <li><Link to="/bookings" className="text-white/65 hover:text-[var(--accent)] transition-colors">Bookings</Link></li>
              <li><Link to="/portfolio" className="text-white/65 hover:text-[var(--accent)] transition-colors">Portfolio</Link></li>
              <li><Link to="/about" className="text-white/65 hover:text-[var(--accent)] transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-white/65 hover:text-[var(--accent)] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg text-white/90 mb-5 tracking-wide">Services</h4>
            <ul className="space-y-3 text-sm">
              <li className="text-white/65">Skin &amp; Facials</li>
              <li className="text-white/65">Lash Extensions</li>
              <li className="text-white/65">Brows &amp; PMU</li>
              <li className="text-white/65">Body &amp; Massage</li>
              <li className="text-white/65">Spray Tans</li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg text-white/90 mb-5 tracking-wide">Find Us</h4>
            <ul className="space-y-4 text-sm text-white/65">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-[var(--accent)] flex-shrink-0" />
                <a
                  href="https://www.google.com/maps/search/?api=1&query=551+Merchant+Street,+Ambridge,+PA+15003"
                  onClick={(e) => { e.preventDefault(); openInMapsApp(SOCIETY_ADDRESS); }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[var(--accent)] transition-colors"
                  data-testid="footer-address-link"
                >
                  551 Merchant Street, Ambridge, PA 15003
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-[var(--accent)] flex-shrink-0" />
                <a
                  href="tel:+17243850145"
                  className="hover:text-[var(--accent)] transition-colors"
                  data-testid="footer-phone-link"
                >
                  724-385-0145
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-[var(--accent)] flex-shrink-0" />
                <a
                  href="mailto:info@welcometosociety.com"
                  className="hover:text-[var(--accent)] transition-colors break-all"
                  data-testid="footer-email-link"
                >
                  info@welcometosociety.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="thin-line mt-14 mb-6 opacity-40" />
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Society Beauty LLC. All rights reserved.</p>
          <p>Beauty isn't a standard. It's a revolution.</p>
        </div>
      </div>
    </footer>
  );
}
